import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/card/super-group-badge.png'


const _hoisted_1 = { class: "card_content" }
const _hoisted_2 = {
  key: 0,
  style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "business-card-name" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = { class: "business-card-desc" }
const _hoisted_7 = { class: "business-card-tip" }

import Header from '@/components/header.vue'
  import { LoadingOutlined } from '@ant-design/icons-vue'
  import { useDark, useNetwork } from '@vueuse/core'
  import {
    computed,
    h,
    onMounted,
    reactive,
    ref,
    useTemplateRef,
    watchEffect,
  } from 'vue'
  import { useRoute } from 'vue-router'
  import PageError from '@/components/page-error.vue'
  import { getGroupShareInfoApi, getUserShareInfoApi } from '@/api/card'
  import useDownloadApp from '@/hooks/useDownloadApp'
  import useOpenApp from '@/hooks/useOpenApp'

  enum Type {
    Group = 'group',
    User = 'user',
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const avatarRef = useTemplateRef('avatarRef')

  const { isOnline } = reactive(useNetwork())

  watchEffect(() => {
    if (!isOnline) {
      isShowPageError.value = true
    }
  })

  const route = useRoute()

  const { downloadApp } = useDownloadApp()
  const { openApp } = useOpenApp()

  const id = computed(() => route.query?.id as string)

  const type = computed(() => route.params.type as Type)

  const isDark = useDark({
    selector: 'html',
    attribute: 'data-theme',
    valueDark: 'dark',
    valueLight: 'light',
  })

  const loading = ref(false)

  const isShowPageError = ref(false)

  const info = reactive<{
    name: string
    portrait: string
    iSuperGroup: boolean
  }>({
    name: '',
    portrait: '',
    iSuperGroup: false,
  })

  const indicator = h(LoadingOutlined, {
    style: {
      fontSize: '56px',
      color: '#38BDF8',
    },
    spin: true,
  })

  const onImgError = () => {
    if (avatarRef.value) {
      avatarRef.value.src = require('@/assets/img/card/avatar.png')
    }
  }

  const getGroupShareInfo = async () => {
    try {
      loading.value = true
      const res = await getGroupShareInfoApi(id.value)

      if (res.value.code === 0) {
        const result = res.value.result

        if (result) {
          const lengths = Object.values(result).filter(Boolean).length

          if (lengths <= 1) {
            isShowPageError.value = true
          } else {
            info.name = result.name
            info.portrait = result.portrait
            if (result?.extra && typeof result.extra === 'string') {
              const extra = JSON.parse(result.extra)

              info.iSuperGroup = extra.daoType === '1'
            }
          }
        } else {
          isShowPageError.value = true
        }
      } else {
        isShowPageError.value = true
      }
    } catch (error) {
      isShowPageError.value = true
    } finally {
      loading.value = false
    }
  }

  const getUserShareInfo = async () => {
    try {
      loading.value = true
      const res = await getUserShareInfoApi(id.value)

      if (res.value.code === 0) {
        if (res.value.result) {
          info.name = res.value.result?.displayName
          info.portrait = res.value.result?.portrait
        } else {
          isShowPageError.value = true
        }
      } else {
        isShowPageError.value = true
      }
    } catch (error) {
      isShowPageError.value = true
    } finally {
      loading.value = false
    }
  }

  onMounted(() => {
    if (route.query.theme === 'dark') {
      isDark.value = true
    } else {
      isDark.value = false
    }

    switch (route.params.type) {
      case Type.Group:
        getGroupShareInfo()
        openApp()
        break
      case Type.User:
        getUserShareInfo()
        openApp()
        break
      default:
        isShowPageError.value = true
        break
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header),
    _createElementVNode("div", _hoisted_1, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_a_spin, { indicator: _unref(indicator) }, null, 8, ["indicator"])
          ]))
        : (isShowPageError.value)
          ? (_openBlock(), _createBlock(PageError, { key: 1 }))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["card_content_inner", {
          'card_content_inner-img': !_unref(isDark),
          'card_content_inner-img-dark': _unref(isDark),
        }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["business-card", {
            'business-card-bg': !_unref(isDark),
            'business-card-bg-dark': _unref(isDark),
          }])
              }, [
                _createElementVNode("img", {
                  ref_key: "avatarRef",
                  ref: avatarRef,
                  class: "avatar",
                  src: info.portrait,
                  onError: onImgError
                }, null, 40, _hoisted_3),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(info.name), 1),
                  (info.iSuperGroup)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(type.value === Type.Group
                ? _ctx.$t('你被邀请加入 Envo 上的群聊')
                : _ctx.$t('邀请你在 Envo 上聊天')), 1),
                _createElementVNode("button", {
                  class: "business-card-btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openApp)()))
                }, _toDisplayString(type.value === Type.Group ? _ctx.$t('加入群聊') : _ctx.$t('开始聊天')), 1),
                _createElementVNode("p", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.$t('在此设备首次使用Envo?')) + " ", 1),
                  _createElementVNode("span", {
                    style: {"color":"#38bdf8"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(downloadApp)()))
                  }, _toDisplayString(_ctx.$t('下载 Envo')), 1)
                ])
              ], 2)
            ], 2))
    ])
  ]))
}
}

})